// Central site configuration — swap these links anytime.
export const SITE = {
  coach: "Dr. Amanjot Kaur",
  company: "IFM FinCoach",
  handle: "@fincoachdraman",
  domain: "fincoachdraman.com",
  tagline: "Your Money Deserves a Plan, Not Just a Paycheck.",
  instagram: "https://www.instagram.com/fincoachdraman",
  quiz: "/quiz",
  payment1on1: "https://smartpay.easebuzz.in/109327/IFM_FinCoach_Fees",
  email: "amanjot@ifmglobal.in",
  portrait:
    "https://customer-assets-0z36b82j.emergentagent.net/job_money-goals-app-9/artifacts/tz470kki_IMG_2152.jpeg",
};
